<template>            
    <v-row>
        <ValidationObserver ref="form" v-slot="{ invalid }" class="displayTemplate">
        <v-col cols="12" xs="12" sm="12" md="12" >
            <v-divider></v-divider>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" class="pt-5">
            <p class="subtitulo">Datos de contacto</p>
        </v-col>
        <v-col cols="12" xs="12" sm="8" md="8" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Nombre de la empresa" rules="required">
                <v-text-field
                    outlined
                    label="Nombre de la empresa"
                    v-model="datosEmpresa.nombre"
                    :error-messages="errors"
                ></v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="py-0" >
            <ValidationProvider v-slot="{ errors }" name="RFC" rules="required|rfc">
                <v-text-field
                    outlined
                    label="RFC"
                    v-model="datosEmpresa.rfc"
                    required
                    id="RFC"
                    maxlength="18"
                    :error-messages="errors"
                ></v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Razón social" rules="required">
                <v-text-field
                    outlined
                    label="Razón social"
                    v-model="datosEmpresa.razon_social"
                    required
                    :error-messages="errors"
                ></v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Télefono" rules="required">
                <v-text-field
                    outlined
                    label="Teléfono" 
                    v-mask="'(###) ###-####'"
                    v-model="datosEmpresa.telefono_contacto" 
                    :error-messages="errors" 
                    required
                ></v-text-field>
            </ValidationProvider>
        </v-col>
         <v-col xs="12" sm="8" md="8" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Dirección" rules="required">
                <v-text-field
                    outlined
                    label="Dirección"
                    v-model="datosEmpresa.direccion"
                    required
                    :error-messages="errors"
                />
            </ValidationProvider>
        </v-col>
        <v-col xs="12" sm="4" md="4" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Código postal" rules="required">
                <v-text-field
                    outlined
                    label="Código postal"
                    v-model="busca_cp"
                    :error-messages="errors"
                    @keyup.enter="busca_codigos()"
                    v-on:keydown.tab="busca_codigos()"
                    v-mask="'#####'"
                />
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="py-0">
            <v-text-field
                outlined
                label="Estado"
                v-model="estado"
                disabled
                class="pa-0 ma-0"
                id="txtEstado"
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="py-0">
            <v-text-field
                outlined
                label="Municipio"
                v-model="municipio"
                disabled
                class="pa-0 ma-0"
                id="txtMunicipio"
            >
            </v-text-field>
        </v-col>
        
        <v-col cols="12" xs="12" sm="4" md="4" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Colonia" rules="required">
                <v-autocomplete
                    outlined
                    label="Colonia"
                    :items="colonias"
                    item-text="nombre"
                    item-value="id"
                    persistent-hint
                    v-model="datosEmpresa.colonia_id"
                    class="pa-0 ma-0"
                    required 
                    :error-messages="errors"
                >
                </v-autocomplete>
            </ValidationProvider>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Calle" rules="required">
                <v-text-field 
                    outlined 
                    label="Calle" 
                    class="pa-0 ma-0" 
                    v-model="datosEmpresa.calle" 
                    required 
                    :error-messages="errors"
                >                                                
                </v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Número interior" rules="required">
                <v-text-field 
                    outlined 
                    label="Número interior" 
                    class="pa-0 ma-0" 
                    v-model="datosEmpresa.interior"
                    required 
                    :error-messages="errors"
                >                                            
                </v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Apoderado" rules="required">
                <v-text-field 
                    outlined 
                    label="Apoderado" 
                    class="pa-0 ma-0" 
                    v-model="datosEmpresa.apoderado" 
                    required 
                    :error-messages="errors"
                >                                               
                </v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Actividad comercial" rules="required">
                <v-textarea
                    v-model="datosEmpresa.actividad_comercial"
                    outlined
                    label="Actividad comercial"
                    :error-messages="errors"
                    required
                    rows="3"
                ></v-textarea>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Dirección contrato" rules="required">
                <v-textarea
                    v-model="datosEmpresa.direccion_contrato"
                    outlined
                    label="Dirección contrato"
                    rows="3"
                    required
                    :error-messages="errors"
                ></v-textarea>
            </ValidationProvider>
        </v-col>

        <!-- <v-col cols="12" xs="12" sm="12" md="12" >
            <v-divider></v-divider>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" class="pt-5">
            <p class="subtitulo">Datos Fiscales</p>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Representante legal" rules="required">
                <v-text-field
                    outlined
                    label="Representante legal"
                    v-model="datosEmpresa.representante_legal"
                    :error-messages="errors"
                ></v-text-field>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Método de pago" rules="required">
                <v-autocomplete
                    outlined
                    label="Método de pago"
                    :items="metodosPagos"
                    item-text="nombre"
                    item-value="id"
                    persistent-hint
                    v-model="datosEmpresa.metodo_de_pago_id"
                    class="pa-0 ma-0"
                    required
                    :error-messages="errors" 
                >
                </v-autocomplete>
            </ValidationProvider>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <ValidationProvider v-slot="{ errors }" name="Banco" rules="required">
                <v-autocomplete
                    outlined
                    label="Banco"
                    :items="bancos"
                    item-text="nombre"
                    item-value="id"
                    persistent-hint
                    v-model="datosEmpresa.banco_empresa_f_id"
                    class="pa-0 ma-0"
                    required
                    :error-messages="errors" 
                >
                </v-autocomplete>
            </ValidationProvider>
        </v-col>
         <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
            <VuetifyDatePicker
                outlined
                v-model="inicio_operaciones"
                label="Inicio de operaciones"
                placeholder="dd/mm/aaaa"
                ref="FechaInicioOperaciones"
            />
        </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                <VuetifyDatePicker
                    outlined
                    v-model="datosEmpresa.fecha_contrato"
                    label="Fecha de contrato"
                    placeholder="dd/mm/aaaa"
                    ref="FechaInicioContrato"
                />
        </v-col> -->
        </ValidationObserver>
    </v-row>
</template>
<script>

    import catalogosApi from "@/api/catalogos";
    import apiBancos from "@/api/bancos";
    import apiMetodoPago from "@/api/metodoPago";
    import Notify from "@/plugins/notify";
    import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';

    export default {
    name:'pop-empresa',
    components:{
        VuetifyDatePicker
    },
    props:{
        oyente:Boolean
    },
    data(){
        return{
        rol:null,
        estado_id:null,
        datosLogin:null,
        datosEmpresa:{
            cliente_id:0,
            nombre:null,
            razon_social:null,
            rfc:null,
            direccion:null,
            cp_id: null,
            estado_id :null,
            municipio_id : null,
            colonia_id : null,
            telefono_contacto : null,
            banco_empresa_f_id : null,
            representante_legal : null,
            fecha_contrato : null,
            inicio_operaciones : null,
            metodo_de_pago_id : null,
            tipo:'gdth',
            formValidate : false,
            calle               : null,
            interior            : null,
            apoderado           : null,
            actividad_comercial : null,
            direccion_contrato  : '',
        }, 
        busca_cp : "",
        estado : null,
        municipio : null,
        bancos : [],
        metodosPagos : [],
        colonias : [],
        fecha_contrato : false,
        inicio_operaciones : false
        }
    },
    props: {
        oyente: {
            type: Boolean,
            default: false
        },
    },
    watch:{
        oyente: function(val){          
            if(val){
                this.recopilaDatos();
            }
        },
        estado_id: function(val){
        this.cambioEstado(val);
        },
        'datosEmpresa.calle':function(val){
            this.formatoDireccionContrato();
        },
        'datosEmpresa.interior':function(val){
            this.formatoDireccionContrato();
        },
        'datosEmpresa.colonia_id':function(val){
            this.formatoDireccionContrato();
        },
        'estado':function(val){
            this.formatoDireccionContrato();
        },
        'municipio':function(val){
            this.formatoDireccionContrato();
        },
        busca_cp: function(val){
            if(val.length == 5){
                this.busca_codigos();
                this.formatoDireccionContrato();
            }
            else{
                this.estado = "";
                this.municipio = "";
                this.colonias = [];
            }
        }
    },
    methods:{
        formatoDireccionContrato(){
            let colonia = this.colonias.find(element => element.id == this.datosEmpresa.colonia_id);
            let nombreColonia = "";
            if(colonia != undefined){
                nombreColonia = colonia.nombre!=undefined ? colonia.nombre : '';
            }
            this.datosEmpresa.direccion_contrato = ("CALLE "+this.datosEmpresa.calle + " NÚMERO " + this.datosEmpresa.interior + " DE LA COLONIA " + nombreColonia + " CÓDIGO POSTAL " + this.busca_cp + " " + this.municipio  + ", " + this.estado).toUpperCase()
            
        },
        recopilaDatos(){
            this.$refs.form.validate().then(result => {
                if(result){                
                    this.datosEmpresa.formValidate = (this.datosEmpresa.formValidate) ? false : this.datosEmpresa.formValidate;            
                }
                else{
                    this.datosEmpresa.formValidate = true;
                }
                this.$emit("save",this.datosEmpresa);              
            });
        },
        resetValues(){
            this.datosEmpresa={
                nombre:null,
                razon_social:null,
                rfc:null,
                direccion:null,
                estado_id:null,
                ciudad_id:null,
                municipio_id: null,
                cp_id: null,
                colonia_id: null,
                url_server_asp:null,
                empresa_id:null,
                cliente_id:null,
                formValidate:false,
                tipo:'gdth',
                calle               : null,
                interior            : null,
                apoderado           : null,
                actividad_comercial : null,
                direccion_contrato  : '',
            }
        },
        getEstados(estado = null){
            let self = this;
            let parametros = {
                paginate:false,
                activo:true,
                order:'asc'
            }

            catalogosApi.getEstados(parametros).then((response) => {
                self.estados = response.data;
            }).catch(err => {
                this.respuesta_error(err);
            });
        },
        cambioEstado(id, ciudad=null){
            this.datosEmpresa.ciudad_id = null;
            let parametros = { activo:true, paginate: false, estado_id: id, order: 'asc'}
            catalogosApi.getCiudades(parametros).then((response)=>{
                this.ciudades = response.data;
            })
            .catch(err => {
                this.respuesta_error(err);
            });
        },
        respuesta_error(error){
            this.loading_guardar= false;
            Swal.fire({
                position: 'center',
                type: 'error',
                title: "Error",
                text: error.response.data.message,
                showConfirmButton: true,
            }) 
        },
        busca_codigos() {
            let self = this;
            let params = {
                activo: true,
                nombre: this.busca_cp,
                include_padres: true,
            };
            catalogosApi.getCP(params).then((response) => {
                let result = response.data;

                if (result.length == 0) {
                    Notify.ErrorToast("No se encontro el Código postal.");
                    this.estado = "";
                    this.municipio = "";
                    this.colonias = [];
                    return;
                }
                this.estado = result[0].nomb_estado;
                this.municipio = result[0].nomb_mun;
                this.datosEmpresa.estado_id = result[0].estado_id;
                this.datosEmpresa.ciudad_id = result[0].municipio_id;
                this.datosEmpresa.municipio_id = result[0].municipio_id;
                this.datosEmpresa.cp_id = result[0].id;

                catalogosApi.getColonias({ codigo_postal_id: result[0].id, order: "asc", paginate: false }).then((response) => {
                    self.colonias = response.data;
                })
                .catch((e) => {
                    Notify.ErrorToast("Se presento un problema al cargar las colonias.");
                    return;
                });
            })
            .catch((e) => {
                console.log(e);
                Notify.ErrorToast("Ocurrió un error al cargar los estados y ciudades.");
            });
        },
        async getCP(id) {
            await catalogosApi.getCodigoPostal(id).then((response) => {
                this.busca_cp = response.nombre;
                this.busca_codigos();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los códigos postales.");
            });
        },
        getBancos(){
            let parametros = { activo:true, paginate:false, order:"asc" }
            apiBancos.find(parametros).then((response) => {
                this.bancos = response.data;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los Bancos.");
            });
        },
        getMetodosPagos(){
            let parametros = { activo:true, paginate:false, order:"asc" }
            apiMetodoPago.find(parametros).then((response) => {
                this.metodosPagos = response.data;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los Métodos de Pagos.");
            });
        },
    },
    created(){                    
        this.resetValues();
        this.getEstados();
        this.getBancos();
        this.getMetodosPagos();
    }
  }
</script>
<style scoped>
.subtitulo{
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #1E2245;
}
.displayTemplate{
    display: contents;
  }
</style>